import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DefectRectificationData } from '../../types/DefectRectificationData';
import { DefectActivity } from '../../types/DefectActivity';
import { DefectDataItem } from '../../types/DefectsDataItem';
import { SharedDefectItem } from '../../types/SharedDefectItem';

export interface RectificationRequestMoreInfo {
    defectId: number;
    inspectionId: string;
    showDialog: boolean;
}

export interface RectificationState {
    data: DefectRectificationData | undefined;
    loading: boolean;
    error: boolean;
    defect: DefectDataItem | SharedDefectItem | undefined;
    activityData: DefectActivity[];
    activityLoading: boolean;
    activityError: boolean;
    requestMoreInfo: RectificationRequestMoreInfo;
    evidenceLoading: boolean;
    showEvidenceDialog: boolean;
    hasEvidence: boolean;
}

export const initialState: RectificationState = {
    data: undefined,
    loading: false,
    error: false,
    defect: undefined,
    activityData: [],
    activityLoading: false,
    activityError: false,
    requestMoreInfo: {
        defectId: 0,
        inspectionId: '',
        showDialog: false,
    },
    evidenceLoading: false,
    showEvidenceDialog: false,
    hasEvidence: false,
};

export const rectificationSlice = createSlice({
    name: 'rectification',
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<DefectRectificationData | undefined>) => {
            state.data = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
        setDefect: (state, action: PayloadAction<DefectDataItem | SharedDefectItem | undefined>) => {
            state.defect = action.payload;
        },
        setActivityData: (state, action: PayloadAction<DefectActivity[]>) => {
            state.activityData = action.payload;
        },
        setActivityLoading: (state, action: PayloadAction<boolean>) => {
            state.activityLoading = action.payload;
        },
        setActivityError: (state, action: PayloadAction<boolean>) => {
            state.activityError = action.payload;
        },
        setRequestMoreInfo: (state, action: PayloadAction<RectificationRequestMoreInfo>) => {
            state.requestMoreInfo = action.payload;
        },
        setEvidenceLoading: (state, action: PayloadAction<boolean>) => {
            state.evidenceLoading = action.payload;
        },
        setShowEvidenceDialog: (state, action: PayloadAction<boolean>) => {
            state.showEvidenceDialog = action.payload;
        },
        setHasEvidence: (state, action: PayloadAction<boolean>) => {
            state.hasEvidence = action.payload;
        },
    },
});

export const {
    setData,
    setLoading,
    setError,
    setDefect,
    setActivityData,
    setActivityLoading,
    setActivityError,
    setRequestMoreInfo,
    setEvidenceLoading,
    setShowEvidenceDialog,
    setHasEvidence,
} = rectificationSlice.actions;

export default rectificationSlice.reducer;
